function toParagraph(text: string) {
  const lines = text.split('\n');
  let result = '';
  for (const line of lines) {
    result += `<p>${line}</p>`;
  }
  return result;
}

const slideOne = {
      title: 'View One',
      image: 'assets/img/slide-1.jpg',
      thumb: 'assets/img/slide-1.jpg',
      hotspots: [
        {
          title: 'Stop & Carry: C-Store',
          number: 1,
          coordinates: {
            top: '37%',
            left: '57%'
          },
          link: 'https://structuralconcepts.com/markets/c-store',
          linkTitle: 'Learn About our C-Store Solutions',
          content: toParagraph('Visit our c-store where we have long recognized the growing trend of convenience stores as a destination for fresh food with display options that not only blend in with the store format but also offer cost-effective configurable turnkey solutions when merchandising strategies change over time.'),
        },
        {
          title: 'Refrigerated & Heated Self-Service Case (B5024RH)',
          number: 2,
          coordinates: {
            top: '57%',
            left: '62%'
          },
          link: 'https://structuralconcepts.com/products/b5024rh',
          linkTitle: 'View Product',
          content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/B5024RH/B5024RH_Web_Environment-1.png'],
          videos: ['OGNA7aob3T0']
        },
        {
          title: 'myDesignPro Product Configurator',
          number: 3,
          coordinates: {
            top: '55%',
            left: '31%'
          },
          link: 'https://structuralconcepts.com/mydesignpro',
          linkTitle: 'Learn About myDesignPro',
          content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up. Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option. See results fast and export them as PDF, Revit or AutoCAD.'),
          images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg'],
          videos: ['E4dqTGHWWyE']
        },
        {
          title: 'Fresh Watch',
          number: 4,
          coordinates: {
            top: '45%',
            left: '34%'
          },
          link: 'https://youtu.be/EzBs2f1soKw',
          linkTitle: 'Learn More',
          content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
          images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
        },
      ]
};

const slideTwo = {
    title: 'View Two',
    image: 'assets/img/slide-2.jpg',
    thumb: 'assets/img/slide-2.jpg',
    hotspots: [
      {
        title: 'Stop & Carry: C-Store',
        number: 1,
        coordinates: {
          top: '35%',
          left: '54%'
        },
        link: 'https://structuralconcepts.com/markets/c-store',
        linkTitle: 'Learn About our C-Store Solutions',
        content: toParagraph('Visit our c-store where we have long recognized the growing trend of convenience stores as a destination for fresh food with display options that not only blend in with the store format but also offer cost-effective configurable turnkey solutions when merchandising strategies change over time.'),
      },
      {
        title: 'Refrigerated & Heated Self-Service Case (B5024RH)',
        number: 2,
        coordinates: {
          top: '63%',
          left: '49%'
        },
        link: 'https://structuralconcepts.com/products/b5024rh',
        linkTitle: 'View Product',
        content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
        images: ['https://djnnwndagrfti.cloudfront.net/resources/B5024RH/B5024RH_Web_Environment-1.png'],
        videos: ['OGNA7aob3T0']
      },
      {
        title: 'myDesignPro Product Configurator',
        number: 3,
        coordinates: {
          top: '46%',
          left: '37%'
        },
        link: 'https://structuralconcepts.com/mydesignpro',
        linkTitle: 'Learn About myDesignPro',
        content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up. Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option. See results fast and export them as PDF, Revit or AutoCAD.'),
        images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg'],
        videos: ['E4dqTGHWWyE']
      },
    ]
};

const slideThree = {
  title: 'View Three',
  image: 'assets/img/slide-3.jpg',
  thumb: 'assets/img/slide-3.jpg',
  hotspots: [
    {
      title: 'myDesignPro Product Configurator',
      number: 3,
      coordinates: {
        top: '41%',
        left: '48%'
      },
      link: 'https://structuralconcepts.com/mydesignpro',
      linkTitle: 'Learn About myDesignPro',
      content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up. Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option. See results fast and export them as PDF, Revit or AutoCAD.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg'],
      videos: ['E4dqTGHWWyE']
    },
    {
      title: 'Fresh Watch',
      number: 4,
      coordinates: {
        top: '41%',
        left: '55%'
      },
      link: 'https://youtu.be/EzBs2f1soKw',
      linkTitle: 'Learn More',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'QC Collection',
      number: 5,
      coordinates: {
        top: '74%',
        left: '58%'
      },
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser that\'s designed to catch attention and encourage quick grab-and-go purchases. The low height allows customers to see fresh food being prepared behind the case while having easy access from the front for quick self-selections.\n\nStraight and corner merchandisers can be combined to customize capacity for each location, and the narrow depth ensures easy installation in virtually any space. A variety of exterior and interior finishes and sizes are available.'),
    },
  ]
};

const slideFour = {
  title: 'View Four',
  image: 'assets/img/slide-4.jpg',
  thumb: 'assets/img/slide-4.jpg',
  hotspots: [
    {
      title: 'myDesignPro Product Configurator',
      number: 3,
      coordinates: {
        top: '43%',
        left: '59%'
      },
      link: 'https://structuralconcepts.com/mydesignpro',
      linkTitle: 'Learn About myDesignPro',
      content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up. Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option. See results fast and export them as PDF, Revit or AutoCAD.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/myDesignPro_image1.jpg'],
      videos: ['E4dqTGHWWyE']
    },
    {
      title: 'Fresh Watch',
      number: 4,
      coordinates: {
        top: '46%',
        left: '65%'
      },
      link: 'https://youtu.be/EzBs2f1soKw',
      linkTitle: 'Learn More',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring, remote diagnostics, and energy optimization that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on power consumption and equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'QC Collection',
      number: 5,
      coordinates: {
        top: '70%',
        left: '38%'
      },
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser that\'s designed to catch attention and encourage quick grab-and-go purchases. The low height allows customers to see fresh food being prepared behind the case while having easy access from the front for quick self-selections.\n\nStraight and corner merchandisers can be combined to customize capacity for each location, and the narrow depth ensures easy installation in virtually any space. A variety of exterior and interior finishes and sizes are available.'),
    },
    {
      title: 'Fusion MD Models',
      number: 6,
      coordinates: {
        top: '35%',
        left: '40%'
      },
      link: 'https://structuralconcepts.com/products/?show=md&collection=Fusion',
      linkTitle: 'View Products',
      content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity — ideal for high-traffic environments where reduced refill frequency is key. Its self-service, open reach-in design promotes easy access to an expansive variety of fresh offerings, while an optional doored version adds flexibility for settings that require added temperature control or customization.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD485DR_Supermarket_Web.png','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-3.jpg','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R-DR4622-1080p-04-09-2024.png']
    },
  ]
};

const slideFive = {
  title: 'View Five',
  image: 'assets/img/slide-5.jpg',
  thumb: 'assets/img/slide-5.jpg',
  hotspots: [
    {
      title: 'QC Collection',
      number: 5,
      coordinates: {
        top: '54%',
        left: '32%'
      },
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser that\'s designed to catch attention and encourage quick grab-and-go purchases. The low height allows customers to see fresh food being prepared behind the case while having easy access from the front for quick self-selections.\n\nStraight and corner merchandisers can be combined to customize capacity for each location, and the narrow depth ensures easy installation in virtually any space. A variety of exterior and interior finishes and sizes are available.'),
    },
    {
      title: 'Fusion MD Models',
      number: 6,
      coordinates: {
        top: '45%',
        left: '47%'
      },
      link: 'https://structuralconcepts.com/products/?show=md&collection=Fusion',
      linkTitle: 'View Products',
      content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity — ideal for high-traffic environments where reduced refill frequency is key. Its self-service, open reach-in design promotes easy access to an expansive variety of fresh offerings, while an optional doored version adds flexibility for settings that require added temperature control or customization.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD485DR_Supermarket_Web.png','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-3.jpg','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R-DR4622-1080p-04-09-2024.png']
    },
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '46%',
        left: '73%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.\n\nOffsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/CSTORE-BD3632IS.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
  ]
};


const slideSix = {
  title: 'View Six',
  image: 'assets/img/slide-6.jpg',
  thumb: 'assets/img/slide-6.jpg',
  hotspots: [
    {
      title: 'QC Collection',
      number: 5,
      coordinates: {
        top: '45%',
        left: '35%'
      },
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser that\'s designed to catch attention and encourage quick grab-and-go purchases. The low height allows customers to see fresh food being prepared behind the case while having easy access from the front for quick self-selections.\n\nStraight and corner merchandisers can be combined to customize capacity for each location, and the narrow depth ensures easy installation in virtually any space. A variety of exterior and interior finishes and sizes are available.'),
    },
    {
      title: 'Fusion MD Models',
      number: 6,
      coordinates: {
        top: '40%',
        left: '52%'
      },
      link: 'https://structuralconcepts.com/products/?show=md&collection=Fusion',
      linkTitle: 'View Products',
      content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity — ideal for high-traffic environments where reduced refill frequency is key. Its self-service, open reach-in design promotes easy access to an expansive variety of fresh offerings, while an optional doored version adds flexibility for settings that require added temperature control or customization.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD485DR_Supermarket_Web.png','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-3.jpg','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R-DR4622-1080p-04-09-2024.png']
    },
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '54%',
        left: '61%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn About the ARM',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.\n\nOffsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/CSTORE-BD3632IS.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
  ]
};

const slides = [
  slideOne,
  slideTwo,
  slideThree,
  slideFour,
  slideFive,
  slideSix,
];


export const slideData = slides.map((slide, parentIndex) => ({
  ...slide,
  hotspots: slide.hotspots.map(hotspot => ({
    ...hotspot,
    parentIndex
  }))
}));
